import React from "react";
import cn from "classnames";
import { MessagePropTypes } from "joynt/components/messages/message/MessagePropTypes";

import {
    MessageBodyBubble,
    MessageFooterCompact,
    MessageHeaderCompact,
} from "joynt/components/messages/message/subcomponents";

import "./style.css";

export function PopupMessage(props) {
    const {
        addReactions,
        className,
        content,
        createdAt,
        files,
        isDeleted,
        isOwn,
        link,
        messageClick,
        notificationStatus,
        onHide,
        reactions,
        id,
        avatar,
    } = props;
    return (
        <article
            className={cn(
                "message",
                { "own-message": isOwn },
                `message--popup`,
                className
            )}
        >
            <MessageHeaderCompact
                {...{ className }}
                avatar={!isOwn ? avatar : null}
            />

            <MessageBodyBubble
                {...{
                    addReactions,
                    content,
                    files,
                    id,
                    isDeleted,
                    isOwn,
                    link,
                    messageClick,
                    onHide,
                }}
            />

            <MessageFooterCompact
                {...{ notificationStatus, reactions, isOwn, createdAt }}
            />
        </article>
    );
}

PopupMessage.propTypes = MessagePropTypes;
